import { useMemo } from 'react'
import { DaysOfWeek, DayOfWeekType } from 'lib/daysOfWeek'
import { HandleBusinessTimeType } from 'types/store'
const daysOfWeek = new DaysOfWeek()

const useRemainingDaysOfWeek = (
  businessTimes: HandleBusinessTimeType[],
  holidays: DayOfWeekType[]
): DayOfWeekType[] => {
  // 営業日か定休日のデータが存在しない場合は、曜日を未選択とみなす
  if (!holidays || !businessTimes) return daysOfWeek.getDaysOfWeek()
  return useMemo(() => {
    return daysOfWeek.getDaysOfWeek().filter((dayOfWeek) => {
      return (
        !holidays.includes(dayOfWeek) &&
        !businessTimes.some((_businessTime) => _businessTime.days_of_week.includes(dayOfWeek))
      )
    })
  }, [businessTimes, holidays])
}

export default useRemainingDaysOfWeek
